<template>
  <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mb-2 mb-lg-3">
    <b-card no-header no-body class="shadow-none border-radius-10 category-titles" :id="`${shortHand}_card`">
      <div class="category-titles-card d-block" v-on:click="onTitleClick()">
        <div class="category-titles-card-header">
          <b-card-title>{{ title }}</b-card-title>
        </div>
        <b-form-group v-if="title == 'Other Debt Payments & Obligations' && !month_debs"
          class="custom-form-control mb-3 p-2">
          <div class="category-titles-card-body">
            <b-row>
              <b-col cols="6" sm="6" md="6" lg="6">
                <div class="inputGroup">
                  <input id="obligationPaymentsYes" type="radio" @click="onYesClick" value="yes" v-model="month_debs"
                    name="obligationPayments" />
                  <label for="obligationPaymentsYes">Yes</label>
                </div>
              </b-col>
              <b-col cols="6" sm="6" md="6" lg="6">
                <div class="inputGroup">
                  <input id="obligationPaymentsNo" type="radio" @click="onNoClick" value="no" v-model="month_debs"
                    name="obligationPayments" />
                  <label for="obligationPaymentsNo">No</label>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-form-group>
        <template v-else>
          <!-- <div
            class="category-titles-card-body clr-box-btns d-flex align-items-center justify-space-between"
          >
            <span
              class="clr-bx-btn category-titles-amount fixed-amount-value"
              v-if="!!fixAmount"
            >
              {{ value2 | currency("$", 0) }}
            </span>
            <span
              class="clr-bx-btn category-titles-amount your-amount-value"
              v-else
            >
              <template v-if="value2>=0">
                {{ value2 | currency("$", 0) }}
              </template>
<template v-else>
                $0
              </template>
</span>
<span class="clr-bx-btn category-titles-amount peers-amount-value" v-if="showPeer">
  {{ value1 | currency("$", 0) }}
</span>
</div> -->
          <div class="category-titles-card-body clr-box-btns d-flex align-items-center">
            <span v-if="!!fixAmount" class="clr-bx-btn text-center py-1 px-1 fixed-amount"
              v-b-tooltip.hover="{ variant: 'primary' }" title="Your Amount"
              :style="{ width: `${percantageCal(value2)}%` }">
              <!-- {{ ((is_homeowner && title == "Rent or Mortgage Payments") ? value2 * 1.33 : value2 ) | currency("$", 0) }} -->
              {{ value2 | currency("$", 0) }}
            </span>
            <span v-else class="clr-bx-btn text-center py-1 px-1 your-amount"
              :class="{ 'negative-bg': getColor(value2) }" v-b-tooltip.hover="{ variant: 'primary' }"
              title="Predicted Amount" :style="{ width: `${percantageCal(value2)}%` }">
              <template v-if="value2 > 0">
                {{ value2 | currency("$", 0) }}
              </template>
              <template v-else>

                {{ value1 | currency("$", 0) }}
              </template>
            </span>
            <span v-if="showPeer" class="clr-bx-btn text-center py-1 px-1 peers-amount"
              :class="{ 'negative-bg': getColor(value1) }" v-b-tooltip.hover="{ variant: 'primary' }" title="Your Peers"
              :style="{ width: `${percantageCal(value1)}%` }">
              {{ value1 | currency("$", 0) }}
            </span>
          </div>

          <div class="edit-budget-amount">
            <div class="d-flex justify-content-between">
              <a role="button" class="mx-2 font-weight-bold your-amount-text">
                <i class="fas fa-pencil-alt mr-1"></i>
                Your Amount
              </a>
              <span class="mx-2 font-weight-bold your-peers-text">
                Your Peers
              </span>
            </div>
          </div>
        </template>
      </div>

      <div :id="`${shortHand}_card_click`" class="add-fudget-form" ref="ddd-n"
        :class="{ 'd-none': isHidden || defaultActiveTab != title }">
        <!-- :class="{ 'd-none': isHidden || defaultActive != title }" -->
        <div class="position-relative d-block">
          <b-form class="m-1" @submit="onSubmit">
            <b-row class="mb-3">
              <b-col cols="6">
                <template v-if="checkIcon">
                  <b-button @click="changeUsesvalue(title)" class="get_advice_btn" size="sm">
                    Ideas
                  </b-button>
                </template>
              </b-col>
              <b-col cols="6" class="text-right">
                <b-button class="about-you-accordion clear-amount-btn" size="sm" variant="danger" @click="
                  fixAmount = null;
                fixAmt();
                ">Reset</b-button>
              </b-col>
            </b-row>
            <b-form-group label="Fixed Amount" class="custom-form-control">
              <NumberInput :model="fixAmount" @changeValue="numberValueChange" name="fixAmount" class="big-input-font"
                ref="field_6" />
            </b-form-group>
            <b-form-group label="Frequency" class="custom-form-control">
              <b-form-select v-model="frequency" :options="[
                { text: 'Monthly', value: 12 },
                { text: 'Weekly', value: 52 },
                { text: 'Quarterly', value: 4 },
                { text: 'Semi-Annually', value: 2 },
                { text: 'Annually', value: 1 },
              ]" :value="null" class="big-input-font">
              </b-form-select>
            </b-form-group>
          </b-form>
          <b-form-group class="text-center">
            <b-button type="button" class="btn-green" size="sm" @click="closeClick()">
              Close
              <!-- Update Edit Amount -->
            </b-button>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <b-modal id="chatGptList" v-model="modalShow" scrollable size="xl" content-class="get-advice-modal"
      v-if="modalShow == true" hide-footer>
      <ChatGptList :uses="uses" />
    </b-modal>
    <div class="dwelling-size-category"
      v-if="defaultActiveTab == 'Rent or Mortgage Payments' && title === 'Rent or Mortgage Payments' && !isHidden">
      <div class="dwelling-size">
        <div class="text-center">
          <h6 class="text-source">
            {{
              selectedZip &&
              ((isSearchZip ? `${selectedZip.zip_code} - ${selectedZip.area_name === this.areaName ? selectedZip.area_name
                : this.areaName}` : (`${selectedZip.area_name === this.areaName ? selectedZip.area_name : this.areaName}`))
                || '')
            }}
          </h6>
          <p class="text-muted small mb-0">Fair Market Rent or Mortgage Payments Estimate by # of Bedrooms</p>
        </div>

        <div class="dwelling-size-badge flex-gap-input d-flex flex-wrap align-items-center justify-content-center my-4">
          <div class="size-badge text-center">
            <h6 class="text-dark font-weight-bold mb-1">Studio</h6>
            <b-button size="sm" class="font-weight-bold rounded btn-fair"
              :class="{ 'btn-active': selectedDwellingSize === (isSearchZip ? 'zip_code_studio' : 'area_studio') }"
              @click="setMortgage((is_homeowner && title == 'Rent or Mortgage Payments') ? selectedZip[isSearchZip ? 'zip_code_studio' : 'area_studio'] * 1.33 : selectedZip[isSearchZip ? 'zip_code_studio' : 'area_studio'], isSearchZip ? 'zip_code_studio' : 'area_studio')"
              type="button">{{
                selectedZip && selectedZip[isSearchZip ? 'zip_code_studio' : 'area_studio'] && usdValue(parseFloat(
                  (is_homeowner && title == "Rent or Mortgage Payments") ? selectedZip[isSearchZip ? 'zip_code_studio' :
                    'area_studio'] * 1.33 : selectedZip[isSearchZip ? 'zip_code_studio' : 'area_studio']).toFixed() || 0)
              }}</b-button>
          </div>
          <div class="size-badge text-center" v-if="title == 'Rent or Mortgage Payments' && !isHidden">
            <h6 class="text-dark font-weight-bold mb-1">1BR</h6>
            <b-button size="sm" class="font-weight-bold rounded btn-fair"
              :class="{ 'btn-active': selectedDwellingSize === (isSearchZip ? 'zip_code_1br' : 'area_1br') }"
              @click="setMortgage((is_homeowner && title == 'Rent or Mortgage Payments') ? selectedZip[isSearchZip ? 'zip_code_1br' : 'area_1br'] * 1.33 : selectedZip[isSearchZip ? 'zip_code_1br' : 'area_1br'], isSearchZip ? `zip_code_1br` : `area_1br`)"
              type="button">{{
                selectedZip && selectedZip[isSearchZip ? 'zip_code_1br' : 'area_1br'] && usdValue(parseFloat((is_homeowner
                  &&
                  title == "Rent or Mortgage Payments") ? selectedZip[isSearchZip ? 'zip_code_1br' : 'area_1br'] * 1.33 :
                  selectedZip[isSearchZip ? 'zip_code_1br' : 'area_1br']).toFixed() || 0)
              }}</b-button>
          </div>
          <div class="size-badge text-center">
            <h6 class="text-dark font-weight-bold mb-1">2BR</h6>
            <b-button size="sm" class="font-weight-bold rounded btn-fair"
              :class="{ 'btn-active': selectedDwellingSize === (isSearchZip ? 'zip_code_2br' : 'area_2br') }"
              @click="setMortgage((is_homeowner && title == 'Rent or Mortgage Payments') ? selectedZip[isSearchZip ? 'zip_code_2br' : 'area_2br'] * 1.33 : selectedZip[isSearchZip ? 'zip_code_2br' : 'area_2br'], isSearchZip ? 'zip_code_2br' : 'area_2br')"
              type="button">{{
                selectedZip && selectedZip[isSearchZip ? 'zip_code_2br' : 'area_2br'] && usdValue(parseFloat((is_homeowner
                  &&
                  title == "Rent or Mortgage Payments") ? selectedZip[isSearchZip ? 'zip_code_2br' : 'area_2br'] * 1.33 :
                  selectedZip[isSearchZip ? 'zip_code_2br' : 'area_2br']).toFixed() || 0)
              }}</b-button>
          </div>
          <div class="size-badge text-center">
            <h6 class="text-dark font-weight-bold mb-1">3BR</h6>
            <b-button size="sm" class="font-weight-bold rounded btn-fair"
              :class="{ 'btn-active': selectedDwellingSize === (isSearchZip ? 'zip_code_3br' : 'area_3br') }"
              @click="setMortgage((is_homeowner && title == 'Rent or Mortgage Payments') ? selectedZip[isSearchZip ? 'zip_code_3br' : 'area_3br'] * 1.33 : selectedZip[isSearchZip ? 'zip_code_3br' : 'area_3br'], isSearchZip ? 'zip_code_3br' : 'area_3br')"
              type="button">{{
                selectedZip && selectedZip[isSearchZip ? 'zip_code_3br' : 'area_3br'] && usdValue(parseFloat((is_homeowner
                  &&
                  title == "Rent or Mortgage Payments") ? selectedZip[isSearchZip ? 'zip_code_3br' : 'area_3br'] * 1.33 :
                  selectedZip[isSearchZip ? 'zip_code_3br' : 'area_3br']).toFixed() || 0)
              }}</b-button>
          </div>
          <div class="size-badge text-center">
            <h6 class="text-dark font-weight-bold mb-1">4BR+</h6>
            <b-button size="sm" class="font-weight-bold rounded btn-fair"
              :class="{ 'btn-active': selectedDwellingSize === (isSearchZip ? 'zip_code_4br' : 'area_4br') }"
              @click="setMortgage((is_homeowner && title == 'Rent or Mortgage Payments') ? selectedZip[isSearchZip ? 'zip_code_4br' : 'area_4br'] * 1.33 : selectedZip[isSearchZip ? 'zip_code_4br' : 'area_4br'], isSearchZip ? 'zip_code_4br' : isSearchZip ? 'zip_code_4br' : 'area_4br')"
              type="button">{{
                selectedZip && selectedZip[isSearchZip ? 'zip_code_4br' : 'area_4br'] && usdValue(parseFloat((is_homeowner
                  &&
                  title == "Rent or Mortgage Payments") ? selectedZip[isSearchZip ? 'zip_code_4br' : 'area_4br'] * 1.33 :
                  selectedZip[isSearchZip ? 'zip_code_4br' : 'area_4br']).toFixed() || 0)
              }}</b-button>
          </div>
        </div>
        <div class="text-center mt-3">
          <h6 class="text-secondary mb-0">Click to select dwelling size</h6>
        </div>
        <div class="roomate-count-dash text-center mt-4">
          <h6 class="col-form-label font-weight-bold mb-2">
            # of Other Roommates Sharing Rent or Mortgage Cost:
          </h6>
          <div class="roomate-count-buttons d-flex justify-content-center flex-wrap">
            <b-button v-for="n in [0, 1, 2, 3, 4]" :key="n" size="sm" class="font-weight-bold mx-1"
              :class="roommatesCount === n ? 'btn-success' : 'btn-secondary'" @click="setRoommates(n)">
              {{ n }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-col>
</template>
<script>
import NumberInput from "@/components/NumberInput";
import ChatGptList from "@/components/ChatGptList";
import transformer_38 from "@/transformers/transformer_new";
import transformer_links from "@/transformers/transformer_links";
export default {
  name: "budget-component",
  props: {
    areaName: String,
    isSearchZip: Boolean,
    selectedDwellingSize: String,
    roomMateCount: Number,
    title: String,
    value1: Number,
    value2: Number,
    frequencyOptions: Array,
    changedValues: Object,
    newValueMorgage: Object,
    newValueVahicle: Object,
    newValueDebt: Object,
    newValueSaving: Object,
    newValueHealth: Object,
    showPeer: Boolean,
    grid: Boolean,
    zip: String,
    age: Array,
    defaultActiveTab: String,
    is_homeowner: Boolean,
    monthDebs: String,
    householdMembers: {
      type: [String, Number],
    }
  },
  components: {
    NumberInput,
    ChatGptList,
  },
  data() {
    return {
      modalShow: false,
      uses: "",
      isHidden: true,
      fixAmount: null,
      frequency: 12,
      defaultActive: "",
      selectedZip: null,
      month_debs: this.monthDebs,
      baseRent: 0,
      roommatesCount: this.roomMateCount || 0,
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  watch: {
    value1(value) {
      console.log("value1", value);
      if (this.title === "Rent or Mortgage Payments")
        this.fetchZips()
    },
    roomMateCount(newVal) {
      this.roommatesCount = newVal;
      this.setRoommates(newVal);
    },
    areaName(value) {
      if (this.title === "Rent or Mortgage Payments")
        this.fetchZips()
    },
    is_homeowner(value) {
      if (this.title === "Rent or Mortgage Payments") {
        let amount = this.fixAmount;
        if (this.fixAmount[0] === '$')
          amount = this.fixAmount.slice(1, this.fixAmount.length + 1);
        console.log(this.fixAmount, value)
        amount = parseFloat(value ? amount * 1.33 : amount / 1.33).toFixed();
        this.fixAmount = amount
        this.setMortgage(amount)
      }
    },
    monthDebs: {
      handler(data) {
        this.month_debs = data;
      },
      deep: true,
    },
    defaultActiveTab: {
      handler(data) {
        this.defaultActive = data;
      },
      deep: true,
    },
    newValueMorgage: function (newVal) {
      if (this.title === "Rent or Mortgage Payments") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueVahicle: function (newVal) {
      if (this.title === "Car Payments") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueDebt: function (newVal) {
      if (this.title === "Other Debt Payments & Obligations") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueSaving: function (newVal) {
      if (this.title == "Amount to Savings Each Period") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueHealth: function (newVal) {
      if (this.title == "Health Insurance") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    grid: {
      handler(val) {
        this.grid = val;
      },
      deep: true,
      immediate: true,
    },
    fixAmount() {
      // this.$emit('changeValue', this.title,this.fixAmount? parseInt(this.unmaskMoneyValue(this.fixAmount))*this.frequency: null,this.fixAmount? this.unmaskMoneyValue(this.fixAmount) :null,this.frequency)
    },
    frequency() {
      this.$emit(
        "changeValue",
        this.title,
        this.fixAmount
          ? parseInt(this.unmaskMoneyValue(this.fixAmount)) * this.frequency
          : null,
        this.fixAmount ? this.unmaskMoneyValue(this.fixAmount) : null,
        this.frequency
      );
    },
  },
  created() { },
  mounted() {
    // alert("mounted called");
    //   localStorage.getItem('roommatesCount') && this.setRoommates(parseInt(localStorage.getItem('roommatesCount')))
    //  console.log("mounted roommatesCount", this.roommatesCount);
  },
  methods: {
    onYesClick() {
      this.month_debs = 'yes'
      this.$emit("openOtherDebt")
    },
    usdValue(val) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      return formatter.format(parseInt(val) || 0);
    },
    onNoClick() {
      const _this = this
      setTimeout(() => {
        _this.month_debs = 'no'
        _this.$parent.month_debs = 'no';
        _this.$emit("submitDebt")
      }, 100);
    },
    setRoommates(count) {
      console.log("setRoommates called with count:", count);
      //this.roommatesCount = count;

      this.updateSharedRent();
      this.changeRoomMate(count);
      
    },

     changeRoomMate(value) {
      this.$emit('roomMateCount', {
        value
      });
    },
    updateSharedRent() {
      if (this.baseRent > 0) {
        const changeValue = parseFloat(
          (this.baseRent / (this.roommatesCount + 1)).toFixed(2)
        );
        this.numberValueChange(parseFloat(changeValue).toFixed(), "fixAmount", true);;
      }
    },

    setMortgage(value, size) {
      console.log("setMortgage123123", value, size);
      this.baseRent = value;
      //this.roommatesCount = 0;
      if (size.length)
        this.$emit('updateDwelling', {
          value: size
        });
      this.numberValueChange(parseFloat(value).toFixed(), "fixAmount", true);
      // if (this.fixAmount === null || this.fixAmount === undefined) {
      // const formatted = parseFloat(value).toFixed();
      // this.fixAmount = formatted;

      this.updateSharedRent();
      this.$nextTick(() => {
        if (this.$refs.field_6) this.$refs.field_6.focus();
      });
      // this.onSubmit()
      // }
    },
    closeClick() {
      this.isHidden = true;
      this.$refs["ddd-n"].classList.add("d-none");
    },
    mangageDwellingSize(dSize) {
      if (dSize === 'zip_code_studio' && !this.isSearchZip)
        return 'area_studio'
      else if (dSize === 'zip_code_1br' && !this.isSearchZip)
        return 'area_1br'
      else if (dSize === 'zip_code_2br' && !this.isSearchZip)
        return 'area_2br'
      else if (dSize === 'zip_code_3br' && !this.isSearchZip)
        return 'area_3br'
      else if (dSize === 'zip_code_4br' && !this.isSearchZip)
        return 'area_4br'
      else if (dSize === 'area_studio' && this.isSearchZip)
        return 'zip_code_studio'
      else if (dSize === 'area_1br' && this.isSearchZip)
        return 'zip_code_1br'
      else if (dSize === 'area_2br' && this.isSearchZip)
        return 'zip_code_2br'
      else if (dSize === 'area_3br' && this.isSearchZip)
        return 'zip_code_3br'
      else if (dSize === 'area_4br' && this.isSearchZip)
        return 'zip_code_4br'
      else
        return dSize
    },
    async fetchZips() {
      try {
        const currentYear = new Date().getFullYear();
        const parsedAges = this.age || [];
        const occupation = this.occupation || "";
        const isNumber = Number(localStorage.getItem('searchZipValue')) >= 0;
        const request = {
          request_id: "test",
          location: isNumber ? this.zip : this.areaName,
          occupation,
          apartment_room_count: "4",
          householdSize: parsedAges.length,
          birthYears: parsedAges.map(a => currentYear - a).join(","),
        };

        const headers = {
          'x-api-key': 'zeN7kb7YRU9N0DGv2M1Yr3wLMnZntYTX3hHl1yVp'
        };

        const res = await this.$http.post(
          "https://api.spendid.io/v2.0/area-costs-analysis",
          request,
          { headers }
        );

        this.suggestions = res.data.plan;
        this.selectedZip = res.data.plan;

        // 🔹 Update fixAmount if a dwelling size is already selected
        if (this.selectedDwellingSize) {
          const sizeKey = this.mangageDwellingSize(this.selectedDwellingSize);
          const newAmount = (this.is_homeowner && this.title === 'Rent or Mortgage Payments')
            ? this.selectedZip[sizeKey] * 1.33
            : this.selectedZip[sizeKey];

          this.setMortgage(newAmount, sizeKey);
        }

      } catch (err) {
        console.error('Failed to fetch zips:', err);
        this.suggestions = [];
      }
    },
    onTitleClick() {
      if (this.title == 'Rent or Mortgage Payments') {
        this.fetchZips();
      }
      this.isHidden = false;
      if (this.title == 'Other Debt Payments & Obligations') {
        if (this.month_debs) {

          this.$parent.month_debs = 'yes';
          this.$emit("openOtherDebt");
        }
        // this.$emit("defaultActiveTabAction", this.title);
      } else {
        this.$emit("defaultActiveTabAction", this.title);
      }
    },
    changeUsesvalue(title) {
      // alert(title)
      const data = {
        title,
        predicted: this.value2,
        peer: this.value1,
        type: "Major",
        zip: this.zip,
        age: this.age[0],
        size: this.age.length,
      };
      this.uses = data;
      this.modalShow = true;
    },
    hideMenus() {
      // this.isHidden = true;
      // this.$refs["ddd-n"].classList.add("d-none");
    },
    onSubmit(event) {
      event.preventDefault();
    },
    getColor(arg) {
      if (arg < 0) {
        return true;
      } else {
        return false;
      }
    },
    fixAmt() {
      this.$emit(
        "changeValue",
        this.title,
        this.fixAmount
          ? parseInt(this.unmaskMoneyValue(this.fixAmount)) * this.frequency
          : null,
        this.fixAmount ? this.unmaskMoneyValue(this.fixAmount) : null,
        this.frequency
      );
    },
    numberValueChange(arg, arg2, fromMortage) {
      if (!fromMortage) {
        if (this.title === "Rent or Mortgage Payments")
          this.$emit('updateDwelling', {
            value: ""
          });
      }
      var self = this;
      self[arg2] = arg;
      this.fixAmt();
    },
    percantageCal(arg) {
      //   if(!!this.fixAmount){
      //     const fixAmount = parseInt(this.unmaskMoneyValue(this.fixAmount))
      //     const total = this.value1+fixAmount

      //     if(typeof arg === 'string')
      //         return (fixAmount/total)*100
      //     else
      //         return (arg/total)*100
      //   } else {
      const total = this.value1 + this.value2;
      if (total === 0 && this.grid === true) return 50;
      else if (total === 0 && this.grid === false) return 4;
      else return (arg / total) * 100;
      //   }
    },
    unmaskMoneyValue(val) {
      if (val && typeof val === "string")
        return val.replace("$", "").replace(",", "");
      else return val;
    },
  },
  computed: {
    checkIcon() {
      const short_hand = Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
      return transformer_links[short_hand];
    },
    shortHand() {
      return Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
    },
  },
};
</script>
